module.exports = __webpack_public_path__ + "static/media/newmusehome.4c14d062.png";